// extracted by mini-css-extract-plugin
export default {"revcontainer":"Review_revcontainer__PvfUv","content":"Review_content__4WT8T","suit":"Review_suit__qamBv"};